import script from "./JobCallsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./JobCallsView.vue?vue&type=script&setup=true&lang=ts"

import "./JobCallsView.vue?vue&type=style&index=0&id=36a82378&scoped=true&lang=css"

import exportComponent from "D:\\Github\\SmsAdminOnlineApplication\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36a82378"]])

export default __exports__